//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './NotificationsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type NotificationsGetListNotificationsQueryParameters = {
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
}

export type NotificationsMarkAsReadNotificationsQueryParameters = {
  id: string ;
}

export type NotificationsDeleteNotificationsQueryParameters = {
  id: string ;
}

export function notificationsGetListUrl(skipCount?: number | undefined, maxResultCount?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/notifications?";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let notificationsGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfNotificationDto, unknown, Types.PagedResultDtoOfNotificationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfNotificationDto, unknown, Types.PagedResultDtoOfNotificationDto>, 'queryFn'>> = {
};
export function getNotificationsGetListDefaultOptions() {
  return notificationsGetListDefaultOptions;
};
export function setNotificationsGetListDefaultOptions(options: typeof notificationsGetListDefaultOptions) {
  notificationsGetListDefaultOptions = options;
}

export function notificationsGetListQueryKey(dto: NotificationsGetListNotificationsQueryParameters): QueryKey;
export function notificationsGetListQueryKey(skipCount?: number | undefined, maxResultCount?: number | undefined): QueryKey;
export function notificationsGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { skipCount, maxResultCount,  } = params[0] as NotificationsGetListNotificationsQueryParameters;

    return trimArrayEnd([
        'NotificationsClient',
        'notificationsGetList',
        skipCount as any,
        maxResultCount as any,
      ]);
  } else {
    return trimArrayEnd([
        'NotificationsClient',
        'notificationsGetList',
        ...params
      ]);
  }
}
export function __notificationsGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.notificationsGetList(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,axiosConfig    );
}

export function useNotificationsGetListQuery<TSelectData = Types.PagedResultDtoOfNotificationDto, TError = unknown>(dto: NotificationsGetListNotificationsQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfNotificationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function useNotificationsGetListQuery<TSelectData = Types.PagedResultDtoOfNotificationDto, TError = unknown>(skipCount?: number | undefined, maxResultCount?: number | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfNotificationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useNotificationsGetListQuery<TSelectData = Types.PagedResultDtoOfNotificationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfNotificationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ skipCount, maxResultCount,  } = params[0] as NotificationsGetListNotificationsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [skipCount, maxResultCount, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfNotificationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __notificationsGetList(context, axiosConfig) : __notificationsGetList,
    queryKey: notificationsGetListQueryKey(skipCount, maxResultCount),
    ...notificationsGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfNotificationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setNotificationsGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfNotificationDto | undefined) => Types.PagedResultDtoOfNotificationDto, skipCount?: number | undefined, maxResultCount?: number | undefined) {
  queryClient.setQueryData(notificationsGetListQueryKey(skipCount, maxResultCount),
    updater
  );
}

/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setNotificationsGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfNotificationDto | undefined) => Types.PagedResultDtoOfNotificationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function notificationsGetUnreadNotificationsCountUrl(): string {
  let url_ = getBaseUrl() + "/api/notifications/unread";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let notificationsGetUnreadNotificationsCountDefaultOptions: Omit<UseQueryOptions<number, unknown, number>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<number, unknown, number>, 'queryFn'>> = {
};
export function getNotificationsGetUnreadNotificationsCountDefaultOptions() {
  return notificationsGetUnreadNotificationsCountDefaultOptions;
};
export function setNotificationsGetUnreadNotificationsCountDefaultOptions(options: typeof notificationsGetUnreadNotificationsCountDefaultOptions) {
  notificationsGetUnreadNotificationsCountDefaultOptions = options;
}

export function notificationsGetUnreadNotificationsCountQueryKey(): QueryKey;
export function notificationsGetUnreadNotificationsCountQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'NotificationsClient',
      'notificationsGetUnreadNotificationsCount',
    ]);
}
export function __notificationsGetUnreadNotificationsCount(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.notificationsGetUnreadNotificationsCount(
axiosConfig    );
}

/**
 * @return OK
 */
export function useNotificationsGetUnreadNotificationsCountQuery<TSelectData = number, TError = unknown>(options?: Omit<UseQueryOptions<number, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useNotificationsGetUnreadNotificationsCountQuery<TSelectData = number, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<number, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<number, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __notificationsGetUnreadNotificationsCount(context, axiosConfig) : __notificationsGetUnreadNotificationsCount,
    queryKey: notificationsGetUnreadNotificationsCountQueryKey(),
    ...notificationsGetUnreadNotificationsCountDefaultOptions as unknown as Omit<UseQueryOptions<number, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setNotificationsGetUnreadNotificationsCountData(queryClient: QueryClient, updater: (data: number | undefined) => number, ) {
  queryClient.setQueryData(notificationsGetUnreadNotificationsCountQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setNotificationsGetUnreadNotificationsCountDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: number | undefined) => number) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function notificationsMarkAsReadUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/notifications/{id}/read";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function notificationsMarkAsReadMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'NotificationsClient',
      'notificationsMarkAsRead',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useNotificationsMarkAsReadMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.NotificationDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.NotificationDto, unknown, void, TContext> {
  const key = notificationsMarkAsReadMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.notificationsMarkAsRead(id),
    mutationKey: key,
  });
}
  
type NotificationsMarkAsRead__MutationParameters = NotificationsMarkAsReadNotificationsQueryParameters

/**
 * @return OK
 */
export function useNotificationsMarkAsReadMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.NotificationDto, unknown, NotificationsMarkAsRead__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: NotificationsMarkAsReadNotificationsQueryParameters}): UseMutationResult<Types.NotificationDto, unknown, NotificationsMarkAsRead__MutationParameters, TContext> {
  const key = notificationsMarkAsReadMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: NotificationsMarkAsRead__MutationParameters) => Client.notificationsMarkAsRead(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function notificationsDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/notifications/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function notificationsDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'NotificationsClient',
      'notificationsDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useNotificationsDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = notificationsDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.notificationsDelete(id),
    mutationKey: key,
  });
}
  
type NotificationsDelete__MutationParameters = NotificationsDeleteNotificationsQueryParameters

/**
 * @return OK
 */
export function useNotificationsDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, NotificationsDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: NotificationsDeleteNotificationsQueryParameters}): UseMutationResult<void, unknown, NotificationsDelete__MutationParameters, TContext> {
  const key = notificationsDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: NotificationsDelete__MutationParameters) => Client.notificationsDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}